import controller from './sales.controller';
import templateBase from './templates/sales-base.view.html';

let SalesComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default SalesComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/sales/sales.component.js